import Tls from "@/services/Tls";

// NAME
const name = "GroupList";

// DATA
const data = () => ({
	filter: null,
	groups: [],
	fields: [
		{
			key:           "id",
			label:         "Référence",
			sortable:      true
		},
		{
			key:           "name",
			label:         "Name",
			sortable:      true,
			sortDirection: "asc"
		},
		{
			key:           "address",
			label:         "Adresse",
			sortable:      true
		},
		{
			label:         "Téléphone",
			key:           "phone",
			sortable:      true
		},
		{
			key:           "created_at",
			label:         "Date de création",
			class: 				 "text-right",
			sortable:      true
		}
	]
});

// METHODS
const fetchGroups = function () {
	Tls.Groups.all().then(responses => {
		this.groups = responses.flatMap(response => response.groups).filter(Boolean);
	});
};

// COMPONENT
export default {
	name,
	data,
	mounted() {
		this.fetchGroups();
	},
	methods: {
		fetchGroups
	}
};